import { Injectable } from '@angular/core';
import { paginateMockData, triggerRandomError } from '../../utils/mock.utils';
import { Paginable } from '../../utils/pagination.utils';
import { REAL_ESTATE_LOCATIONS_MOCK } from './real-estate-locations.mock';
import { RealEstateLocationMunicipalityPaginableParams, RealEstateLocationNeighborhoodPaginableParams, RealEstateLocationSearchParams, RealEstateLocationStatePaginableParams, RealEstateLocationSuggestion, RealEstateLocationsService } from './real-estate-locations.service';

@Injectable()
export class RealEstateLocationsServiceMock implements RealEstateLocationsService {
  async getAllMunicipalities(params: RealEstateLocationMunicipalityPaginableParams): Promise<Paginable<string>> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }
        const data = [...new Set(REAL_ESTATE_LOCATIONS_MOCK.filter((location) => location.state === params.state).map((location) => location.municipality))].sort();
        resolve(paginateMockData(data, params));
      }, 1000);
    });
  }

  async getAllNeighborhoods(params: RealEstateLocationNeighborhoodPaginableParams): Promise<Paginable<string>> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }
        const data = [...new Set(REAL_ESTATE_LOCATIONS_MOCK.filter((location) => location.state === params.state && location.municipality === params.municipality).map((location) => location.neighborhood))].sort();
        resolve(paginateMockData(data, params));
      }, 1000);
    });
  }

  async getAllStates(params: RealEstateLocationStatePaginableParams): Promise<Paginable<string>> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }
        const data = [...new Set(REAL_ESTATE_LOCATIONS_MOCK.map((location) => location.state))].sort();
        resolve(paginateMockData(data, params));
      }, 1000);
    });
  }

  async search(params: RealEstateLocationSearchParams): Promise<RealEstateLocationSuggestion[]> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }

        const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const term = normalize(params.term.trim());
        const states: RealEstateLocationSuggestion[] = [...new Set(REAL_ESTATE_LOCATIONS_MOCK.map((location) => location.state))]
          .map((state) => ({ label: state, state }));
        const municipalities: RealEstateLocationSuggestion[] = [...new Set(REAL_ESTATE_LOCATIONS_MOCK.map((location) => `${location.municipality}|${location.state}`))]
          .map((value) => {
            const [municipality, state] = value.split('|');
            return { label: `${municipality}, ${state}`, municipality, state };
          });
        const settlements: RealEstateLocationSuggestion[] = REAL_ESTATE_LOCATIONS_MOCK.map((location) => ({
          label: `${location.neighborhood}, ${location.municipality}, ${location.state}`,
          municipality: location.municipality,
          settlement: location.neighborhood,
          state: location.state,
        }));

        resolve([...states, ...municipalities, ...settlements]
          .filter((suggestion) => normalize(suggestion.label).includes(term))
          .slice(0, params.limit));
      }, 1000);
    });
  }
}
